"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useFlash = exports.FlashProvider = exports.FlashContext = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FlashReducer = _interopRequireDefault(require("./FlashReducer"));

// initial state
var initialState = {
  messages: []
}; // create context

var FlashContext = /*#__PURE__*/(0, _react.createContext)(initialState); // providor component

exports.FlashContext = FlashContext;

var FlashProvider = function FlashProvider(_ref) {
  var children = _ref.children;

  var _useReducer = (0, _react.useReducer)(_FlashReducer.default, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1]; // dispatch actions to reducer


  function addMessage(text, options) {
    var message = (0, _objectSpread2.default)({
      text: text
    }, options);
    dispatch({
      type: 'ADD_MESSAGE',
      payload: message
    });
  }

  function dismissMessage(messageId) {
    dispatch({
      type: 'DISMISS_MESSAGE',
      payload: messageId
    });
  }

  function cycleMessage(messageId) {
    dispatch({
      type: 'CYCLE_MESSAGE',
      payload: messageId
    });
  } // render


  return /*#__PURE__*/_react.default.createElement(FlashContext.Provider, {
    value: {
      messages: state.messages,
      addMessage: addMessage,
      dismissMessage: dismissMessage,
      cycleMessage: cycleMessage
    }
  }, children);
}; // a hook to use flash values


exports.FlashProvider = FlashProvider;

var useFlash = function useFlash() {
  var flash = _react.default.useContext(FlashContext);

  return flash;
};

exports.useFlash = useFlash;